import {post} from './util/http'
import store from '../store/store'

export const currencyList = () => {
  return post('/Util/currencyList')
}

export const login = (userName, pwd, userType) => {
  return post('/User/webLogin', {userName: userName, pwd: pwd, userType: userType}, true)
}

export const userReg = (email, pwd) => {
  return post('/User/userReg', {
    userName: email,
    email: email,
    mobile: '',
    pwd: pwd,
    parentUid: ''
  }, true)
}
export const forgetPwd = (email) => {
  return post('/User/forgetPwd', {
    email: email
  })
}
export const forgetPwdChkCode = (email, code) => {
  return post('/User/forgetPwdChkCode', {
    email: email,
    code: code
  })
}
export const forgetPwdSetByCode = (token, pwd) => {
  return post('/User/forgetPwdSetByCode', {
    token: token,
    pwd: pwd
  })
}

export const holidayList = (year) => {
  return post('/Util/holidayList', {year: year})
}
export const chkLogin = () => {
  return post('/User/chkLogin')
}
export const chkVersion = () => {
  return post('/Util/chkVersion', {
    channel: 'pc'
  })
}
export const advlist = (classType, limit) => {
  classType = typeof classType === 'undefined' ? '首页广告' : classType
  limit = typeof limit === 'undefined' ? 12 : limit
  return post('/Util/advlist', {
    classType: classType,
    limit: limit
  })
}
export const updateProfile = (params) => {
  return post('/User/updateProfile', params)
}
export const appInfo = (params) => {
  return post('/Util/appInfo')
}
export const getMacauCate = () => {
  return post('/macau/getMacauCate')
}
export const getMacauEventList = (page) => {
  return post('/macau/eventList', {kw: '', page: page})
}

export const getMacauCateList = (id) => {
  return post('/macau/getMacauCateList', {page: 1, limit: 999, id: id})
}

export const getPromptTagList = (id) => {
  return post('/Util/getPromptTagList', {id: id})
}

export const loadPromp = (id, list) => {
  return post('/Util/loadPromp', {id: id, Currency: store.state.currency, list: list})
}
export const article = (id) => {
  return post('/Util/article', {id: id})
}

export const loadPromptTagList = (id) => {
  return new Promise((resolve, reject) => {
    getPromptTagList(id).then(res => {
      if (res.code === 200) {
        let baseProduct = res.data.map(item => {
          if (item.List.length > 0) {
            return {
              tagId: item.List[0].tagID,
              name: item.key,
              List: item.List.map(lItem => {
                return {
                  PName: lItem.PName,
                  SmallPhoto: lItem.SmallPhoto,
                  id: lItem.productID,
                  type: lItem.type,
                  dataSource: lItem.dataSource.replace(/\./g, '')
                }
              })
            }
          }
          return {}
        })
        loadPromp(id, res.data).then(res2 => {
          const avaProduct = {}
          if (res2.code === 200) {
            for (let x in res2.data) {
              for (let i in res2.data[x]) {
                let id = x === 'Hotel' ? res2.data[x][i].id : res2.data[x][i].Sid
                avaProduct[`${x}_${res2.data[x][i].dataSource}_${id}`] = {
                  type: x,
                  id: id,
                  dataSource: res2.data[x][i].dataSource,
                  discount: res2.data[x][i].discount,
                  Price: res2.data[x][i].Price
                }
              }
            }
          }
          baseProduct = baseProduct.map(item => {
            return {
              tagId: item.tagId,
              name: item.name,
              List: item.List.filter(lItem => {
                return typeof avaProduct[`${lItem.type}_${lItem.dataSource}_${lItem.id}`] !== 'undefined'
              }).map(lItem => {
                return {
                  ...lItem,
                  ...avaProduct[`${lItem.type}_${lItem.dataSource}_${lItem.id}`]
                }
              })
            }
          })
          resolve(baseProduct)
        })
      } else {
        reject(res.data)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/service/util.js